import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";

export function Comunidad() {
  return (
    <div className="container" style={{ marginTop: 60, paddingTop: 0, paddingBottom: 0 }}>
      <Reveal>
        <div className="comunidad-card" style={{
          background: "linear-gradient(150deg,#33302B,#413A31)", borderRadius: 32, padding: "54px 48px",
          position: "relative", overflow: "hidden",
        }}>
          <div style={{
            position: "absolute", right: -60, top: -60, width: 280, height: 280,
            background: "radial-gradient(circle, var(--sage), transparent 70%)", opacity: 0.22,
          }} />
          <div className="grid-2" style={{ position: "relative", gridTemplateColumns: ".9fr 1.1fr" }}>
            <div>
              <div className="label-eyebrow" style={{ background: "rgba(231,215,192,.14)", border: "1px solid rgba(231,215,192,.28)", color: "var(--sand)", marginBottom: 22 }}>
                El corazón de PzicoDosis
              </div>
              <h2 className="fluid-heading-md comunidad-title" style={{ fontFamily: "var(--font-display)", fontWeight: 800, lineHeight: 1.06, letterSpacing: "-0.02em", margin: "0 0 18px", color: "var(--on-dark)" }}>
                Una comunidad que se cuida en voz alta
              </h2>
              <p className="mobile-text-md" style={{ lineHeight: 1.6, color: "var(--on-dark-muted)", margin: "0 0 26px" }}>
                Foros por categoría acompañados por nuestro psicólogo y su equipo de soporte. Comparte, responde, da apoyo y descubre que lo que sientes también lo sienten otras personas.
              </p>
              <Link to="/comunidad" className="btn btn-dark">Entra al foro</Link>
            </div>

            <div className="hide-mobile" style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              <div style={{ background: "var(--bg)", borderRadius: 18, padding: "18px 20px", boxShadow: "var(--shadow-card-lg)" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
                  <span style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "#F4E7DC", borderRadius: 999, padding: "4px 11px", fontSize: 12, fontWeight: 700, color: "var(--copper)" }}>
                    <span style={{ width: 7, height: 7, borderRadius: "50%", background: "#C98B6B" }} />Ansiedad
                  </span>
                  <span style={{ fontSize: 12, color: "var(--muted-3)" }}>hace 2 h</span>
                </div>
                <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 6 }}>¿Cómo manejan la ansiedad de los domingos?</div>
                <div style={{ fontSize: 14, color: "var(--muted)", lineHeight: 1.5, marginBottom: 12 }}>
                  Cada domingo en la tarde me llega esta sensación de nudo… ¿les pasa? ¿qué les ayuda?
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 18, color: "var(--muted-2)", fontSize: 13, fontWeight: 600 }}>
                  <span>♡ 48</span><span>💬 23 respuestas</span>
                </div>
              </div>
              <div style={{ background: "var(--bg)", borderRadius: 18, padding: "18px 20px", boxShadow: "var(--shadow-card-lg)", marginLeft: 24 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
                  <span style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "var(--sage-soft)", borderRadius: 999, padding: "4px 11px", fontSize: 12, fontWeight: 700, color: "#5E8068" }}>
                    <span style={{ width: 7, height: 7, borderRadius: "50%", background: "var(--sage)" }} />Mindfulness
                  </span>
                  <span style={{ fontSize: 12, color: "var(--muted-3)" }}>hace 5 h</span>
                </div>
                <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 6 }}>Mi ritual de 3 minutos antes de dormir</div>
                <div style={{ display: "flex", alignItems: "center", gap: 18, color: "var(--muted-2)", fontSize: 13, fontWeight: 600, marginTop: 10 }}>
                  <span>♡ 112</span><span>💬 31 respuestas</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  );
}
